import { getLogger } from '../logger.ts';

const logger = getLogger('gateway.action');
const level = 'info';

export function logAction(group: string, message: () => string): void{
    const groupLogger = logger.child(group);
    if (groupLogger.enabledFor(level)) {
        const msg = message();
        groupLogger[level](msg);
    }
}
